'use client';

import { AuthContext } from '@/contexts/AuthContext/AuthContext';
import { useContext } from 'react';

export const useAuth = () => {
  const { isAdmin, isLoggedIn, isLoading, user, isBackendRejected } = useContext(AuthContext);

  return {
    isLoggedIn,
    isLoading,
    isAdmin,
    user,
    isBackendRejected,
  };
};
